import { render, staticRenderFns } from "./NoticeSoldier.vue?vue&type=template&id=5a9d4bf6&scoped=true"
import script from "./NoticeSoldier.vue?vue&type=script&lang=js"
export * from "./NoticeSoldier.vue?vue&type=script&lang=js"
import style0 from "./NoticeSoldier.vue?vue&type=style&index=0&id=5a9d4bf6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d4bf6",
  null
  
)

export default component.exports